import { Search } from "@mui/icons-material";
import {
  Box,
  FormControl,
  IconButton,
  InputBase,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const Dropdown = ({
  onChange = () => {
    return null;
  },
  data = [],
  label,
  value = "",

  disabled = false,
  readOnly,
  err,
  feild
}) => {
  return (
    <>
      <FormControl disabled={disabled}>
        <InputLabel id="demo-simple-select-readonly-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-readonly-label"
          id="demo-simple-select-readonly"
          value={value}
          label={label}
          onChange={(e) => onChange(e.target.value)}
          inputProps={{ readOnly: readOnly }}
        >
          {data?.map((item, index) => (
            <MenuItem value={feild ? item[feild] :item?.guidRecNo} key={item?.guidRecNo}>
              {item?.chName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default Dropdown;
